import { Account as AccountFeature } from '../../../features/account/components/account';

const Account = () => <AccountFeature />;

export { Account };
